import { AppBarModuleAndPinningTuiGroup, AppsModuleTuiItem, NewUserAllSetTuiItem, NewUserUploadTuiItem, } from '../shared';
import { ConsumerDarkModeStandaloneTuiItem, ConsumerMyContentTuiItem, ConsumerNewUserCreateTuiItem, ConsumerNewUserUpgradeTuiItem, ConsumerPinnedFavoritesTuiItem, FreemiumReminderTuiItem, } from './tui-items';
export var ConsumerTuiConfig = {
    newUserTuiSequence: [
        ConsumerNewUserCreateTuiItem,
        ConsumerMyContentTuiItem,
        AppsModuleTuiItem,
        NewUserUploadTuiItem,
        ConsumerNewUserUpgradeTuiItem,
        NewUserAllSetTuiItem,
    ],
    returningUserTuiSequence: [
        FreemiumReminderTuiItem,
        ConsumerPinnedFavoritesTuiItem,
        ConsumerMyContentTuiItem,
        AppBarModuleAndPinningTuiGroup,
    ],
    standaloneTuiItems: [ConsumerDarkModeStandaloneTuiItem],
};
//# sourceMappingURL=config.js.map